import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from '@/store'

import axios from 'axios';
import './assets/styles/common.css'

import noData from './components/noData.vue' // 无数据

import common from './assets/js/common';
Vue.prototype.$common = common;


Vue.component('noData',noData) // 无数据
Vue.prototype.$bus= new Vue()
Vue.prototype.$https=axios;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
